<template>
  <v-card
    color="grey lighten-4"
    min-width="380px"
    flat>
    <v-toolbar
      :color="$attrs.event.color"
      dark>
      <v-toolbar-title v-html="$attrs.event.name" />
      <v-spacer />
      <v-spacer />
      <v-tooltip
        v-if="mypacient.length > 0"
        bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            v-on="on"
            @click="goPacient">
            <v-icon>mdi-account-check</v-icon>
          </v-btn>
        </template>
        <span>Mergi la pacient</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            v-on="on"
            @click="editItem">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </template>
        <span>Editeaza</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            v-on="on"
            @click="closeBox">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </template>
        <span>Inchide</span>
      </v-tooltip>
    </v-toolbar>
    <v-card-text>
      <div class="p5 capitalize bold">
        <v-icon class="pr10">mdi-clock-outline</v-icon>
        {{ $attrs.startdayname }}, {{ $attrs.startday }}
        {{ $attrs.startmonth }} {{ $attrs.startyear }} |
        {{ $attrs.starttime }} - {{ $attrs.endtime }}
      </div>
      <div
        v-if="$attrs.event.status === 'p5'"
        class="p5">
        <v-icon class="pr10">mdi-cancel</v-icon>
        <b>Motivul anularii:</b>
        <span v-html="$attrs.event.anulareN" />
      </div>
      <div
        v-if="$attrs.event.status !== 'p5'"
        class="p5">
        <v-icon class="pr10">mdi-tooth</v-icon>
        <b>Operatiune:</b>
        <span v-html="$attrs.event.service" />
      </div>
      <div
        v-if="$attrs.event.status !== 'p5'"
        class="p5">
        <b v-if="$attrs.event.mention">Observatii:</b>
        <span v-html="$attrs.event.mention" />
      </div>
    </v-card-text>
    <v-divider v-if="$attrs.event.status === 'p1'" />
    <v-card-actions v-if="$attrs.event.status === 'p1'">
      <div>Acceptati?</div>
      <v-spacer />
      <v-btn @click="acceptItem">
        Da
      </v-btn>
      <v-btn @click="rejectItem">
        Nu
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import { mapActions } from 'vuex'
import router from '@/router'
import axios from 'axios'
import { URL } from '../../variables'
export default {
  name: 'Programare',
  data () {
    return {
      idMedic: localStorage.getItem('useruid'),
      uidMedic: localStorage.getItem('useruuid')
    }
  },
  computed: {
    pacient () {
      var identificator = this.$attrs.event.idPacient
      return this.$store.state.Pacienti.pacienti.filter(function (e) {
        return e.uid == identificator
      })
    },
    mypacient () {
      var pac = []
      for (var i = 0; i < this.pacient[0].uidMedic.length; i++) {
        if (this.pacient[0].uidMedic[i].target_id == this.idMedic) {
          pac.push({ medicId: this.pacient[0].uidMedic[i].target_id })
        }
      }
      return pac
    },
    mediciPacient () {
      var pac = [{ target_id: this.idMedic }]
      for (var i = 0; i < this.pacient[0].uidMedic.length; i++) {
        pac.push({ target_id: this.pacient[0].uidMedic[i].target_id })
      }
      return pac
    }
  },
  mounted () {
    this.loadPacienti()
  },
  methods: {
    ...mapActions('Pacienti', ['loadPacienti']),
    ...mapActions('Programari', ['acceptareProgramare']),
    closeBox () {
      this.$emit('closeBox', false)
    },
    goPacient () {
      router.push({ path: '/pacient/' + this.$attrs.event.idPacient })
    },
    acceptItem () {
      if (this.mypacient.length == 0) {
        this.saveAsPacient({
          uid: this.$attrs.event.idPacient,
          medicId: this.mediciPacient,
          device: this.pacient[0].device
        })
      }
      this.acceptareProgramare({
        nid: this.$attrs.event.nid,
        status: 'p2',
        device: this.pacient[0].device,
        title: 'Programare acceptata!',
        text: 'Programarea ta a fost acceptata de'
      })
      this.$attrs.event.color = 'green'
      this.$attrs.event.status = 'p2'
      this.$emit('acceptItem', false)
    },
    rejectItem () {
      this.acceptareProgramare({
        nid: this.$attrs.event.nid,
        status: 'p3',
        device: this.pacient[0].device,
        title: 'Programare acceptata!',
        text: 'Programarea ta a fost acceptata de'
      })
      this.$attrs.event.color = 'red'
      this.$attrs.event.status = 'p3'
      this.$emit('rejectItem', false)
    },
    editItem () {
      router.push({
        path: 'programare/' + this.$attrs.event.nid,
        query: {
          nid: this.$attrs.event.nid,
          uid: this.$attrs.event.idPacient,
          uuid: this.$attrs.event.uuidPacient,
          start: this.$attrs.event.start,
          end: this.$attrs.event.end,
          status: this.$attrs.event.status,
          service: this.$attrs.event.service,
          mention: this.$attrs.event.mention,
          name: this.$attrs.event.name,
          fullnume: this.pacient[0].fullnume,
          color: this.$attrs.event.color,
          anulareN: this.$attrs.event.anulareN
        }
      })
    },
    saveAsPacient (payload) {
      var data = {
        field_my_medic: payload.medicId
      }
      let config = {
        headers: {
          'Content-Type': 'application/json'
        }
      }
      return axios
        .patch(URL + '/user/' + payload.uid + '?_format=json', data, config)
        .then((response) => Promise.resolve(response.data))
        .catch((error) => Promise.reject(error))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/programari/Programare.vue